<template>
  <div
    class="flex items-center justify-between gap-x-2"
    data-testid="appMenuDesktop">
    <ul class="flex gap-x-8">
      <li
        v-for="item in desktopItems"
        :key="item.label"
        class="flex items-center">
        <AppMenuItem
          :item="item"
          active-class="bg-primary isActive hover:bg-primary text-neutral"
          inactive-class="hover:bg-neutral-pale text-neutral-emphasis hover:text-neutral-primary"
          item-class="text-xs inline-block group tracking-wider leading-4.5 uppercase font-semibold px-2 py-0.5 rounded-full"
          @item-clicked="
            trackEvent('header_click_textButton_navlink', item.url.fullPath)
          " />
      </li>
    </ul>
    <div class="ml-auto flex items-center justify-between gap-x-6">
      <AppMenuFeedbackButton
        @item-clicked="
          trackEvent(
            'header_click_button_feedback',
            `${t('navigation.feedback')}/mailto:dpa-news-hub@dpa.com`,
          )
        " />
      <div class="flex items-center gap-x-3.5">
        <RouterLink
          v-if="isPermittedForNewsfeed()"
          v-slot="{ isActive, navigate, href }"
          :custom="true"
          :to="{ name: 'bookmark' }">
          <a :href="href" @click="navigate">
            <UiTooltip
              :fixed="false"
              animate
              :hidden="isMobile"
              position="bottom">
              <template #activator>
                <UiButton
                  v-if="bookmarksStore.bookmarksCount > 0"
                  :appearance="isActive ? 'fill-emphasis' : 'ghost'"
                  :aria-label="t('bookmarks.title')"
                  size="sm">
                  <UiIcon name="bookmark-filled" />
                </UiButton>
                <UiButton
                  v-else
                  :appearance="isActive ? 'fill-emphasis' : 'ghost'"
                  :aria-label="t('bookmarks.title')"
                  size="sm">
                  <UiIcon name="bookmark" />
                </UiButton>
              </template>
              {{ t("bookmarks.title") }}
            </UiTooltip>
          </a>
        </RouterLink>

        <RouterLink
          v-slot="{ isActive, navigate, href }"
          :custom="true"
          :to="{
            name: 'settingsPage',
          }">
          <a :href="href" @click="navigate">
            <UiTooltip :fixed="false" animate :hidden="isMobile">
              <template #activator>
                <UiButton
                  :appearance="isActive ? 'fill-emphasis' : 'ghost'"
                  :aria-label="t('settings.title')"
                  size="sm">
                  <UiIcon name="settings" />
                </UiButton>
              </template>
              {{ t("settings.title") }}
            </UiTooltip>
          </a>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import UiButton from "@dpa-id-components/dpa-shared-components/src/components/UiButton/UiButton.vue";
import UiIcon from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import UiTooltip from "@dpa-id-components/dpa-shared-components/src/components/UiTooltip/UiTooltip.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import useAuthorization from "@/composition/shared/useAuthorization.ts";
import useBreakpoints from "@/composition/shared/useBreakpoints.ts";
import useNavigation from "@/composition/shared/useNavigation.ts";
import { useTracking } from "@/composition/shared/useTracking.ts";
import { useBookmarksStore } from "@/stores/bookmarks.ts";

import AppMenuFeedbackButton from "./AppMenuFeedbackButton.vue";
import AppMenuItem from "./AppMenuItem.vue";

const { t } = useI18n();
const { navigationItems } = useNavigation();
const { isMobile } = useBreakpoints();

const { isPermittedForNewsfeed } = useAuthorization();
const desktopItems = computed(() => {
  return navigationItems.value.filter((item) => !item.mobileOnly);
});

const { trackEvent } = useTracking();

const bookmarksStore = useBookmarksStore();
</script>
